class ShareButton extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // Defer init so DOM is ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.init());
        } else {
            this.init();
        }
    }

    init() {
        this.popup = document.getElementById('halo-share-popup');
        if (!this.popup) return;

        this.urlInput = this.popup.querySelector('.field__input');
        this.copyButton = this.popup.querySelector('.button-copy');
        this.closeButton = this.popup.querySelector('[data-close-share-popup]');
        this.successMessage = this.popup.querySelector('[id^="ShareMessage"]');

        // Open button (inside the product form)
        const openBtn = this.querySelector('[data-open-share-popup]');
        if (openBtn) {
            openBtn.addEventListener('click', this.open.bind(this));
        }

        // Close button (inside the popup)
        if (this.closeButton) {
            this.closeButton.addEventListener('click', this.close.bind(this));
        }

        // Copy button
        if (this.copyButton) {
            this.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
        }

        // Overlay click to close
        const backgroundOverlay = document.querySelector('.background-overlay');
        if (backgroundOverlay) {
            backgroundOverlay.addEventListener('click', this.close.bind(this));
        }
    }

    open(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.popup || !this.urlInput) return;

        const url = this.urlInput.getAttribute('data-url');
        this.urlInput.setAttribute('value', url);
        this.urlInput.classList.remove('is-copy');

        if (this.successMessage) {
            this.successMessage.classList.add('hidden');
        }

        this.popup.classList.add('is-show');
        document.body.classList.add('share-popup-show');
    }

    close(event) {
        if (event) {
            event.preventDefault();
        }
        if (!this.popup) return;

        if (this.urlInput) {
            const url = this.urlInput.getAttribute('data-url');
            this.urlInput.setAttribute('value', url);
            this.urlInput.classList.remove('is-copy');
        }

        if (this.successMessage) {
            this.successMessage.classList.add('hidden');
        }

        this.popup.classList.remove('is-show');
        document.body.classList.remove('share-popup-show');
    }

    copyToClipboard(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.urlInput) return;

        if (!this.urlInput.classList.contains('is-copy')) {
            navigator.clipboard.writeText(this.urlInput.value).then(() => {
                if (this.successMessage) {
                    this.successMessage.setAttribute('aria-hidden', false);
                    this.successMessage.classList.remove('hidden');
                }

                this.urlInput.setAttribute('value', 'Link copied to clipboard!');
                this.urlInput.classList.add('is-copy');

                setTimeout(() => {
                    if (this.successMessage) {
                        this.successMessage.setAttribute('aria-hidden', true);
                    }
                }, 6000);
            });
        }
    }
}

if (!customElements.get('share-button')) {
    customElements.define('share-button', ShareButton);
}

// Legacy compatibility placeholder
window.shareProduct = function () {};